var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-title"},[_c('div',{staticClass:"step-status-icon",class:{ active: _vm.active, error: _vm.error, complete: _vm.complete }},[_c('DsIcon',{attrs:{"name":_vm.icon}})],1),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }